import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-zcash', 'CurrencyZcash', [["path",{"d":"M7 6h10l-10 12h10"}],["path",{"d":"M12 4v2"}],["path",{"d":"M12 18v2"}]]);